import { render, staticRenderFns } from "./FlatWeb.vue?vue&type=template&id=1f585c10&scoped=true&"
import script from "./FlatWeb.vue?vue&type=script&lang=js&"
export * from "./FlatWeb.vue?vue&type=script&lang=js&"
import style0 from "./FlatWeb.vue?vue&type=style&index=0&id=1f585c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f585c10",
  null
  
)

export default component.exports